import Vue from 'vue';
import gsap from 'gsap/all';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';


Vue.component('navigation-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {

        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.$root.$on('close-menu-from-transition', this.closeMenuFromPageTransition);
        this.$root.$on('toggle-menu', this.toggleMenu);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleMenu() {
            // if (this.$root.inTransition) {
            //     return;
            // }

            this.$root.inTransition = true;

            if (document.body.classList.contains('menu-open')) {
                this.closeMenu();
            } else if (document.body.classList.contains('testimonial-open')) {
                this.closeTestimonial();
            } else {
                this.openMenu();
            }
        },

        closeTestimonial() {
            const onReverseComplete = () => {
                this.$root.inTransition = false;
                gsap.set(['#header', '#overlay-testimonials', '.header__logo-link'], { clearProps: "all" });
            };

            document.body.classList.remove('testimonial-open');
            enableBodyScroll(document.querySelector('#overlay-testimonials'));
            gsap.to('.testimonials-wrapper', { autoAlpha: '0' });

            // Close for mobile.
            if (window.matchMedia("(max-width: 1023px)").matches) {
                gsap.to('.hamburger__line4', { duration: 0.2, rotate: 0 });
                gsap.to('.hamburger__line2', { duration: 0.2, rotate: 0 });
                gsap.to('.hamburger__line1', { delay: 0.4, duration: 0.2, scaleX: 1 });
                gsap.to('.hamburger__line3', { delay: 0.4, duration: 0.2, scaleX: 1 });
                gsap.to('.hamburger__line3', { delay: 0.9, duration: 0.2, width: '20px', autoAlpha: 1 });
                gsap.to("#header", { duration: 2, height: '72px', ease: 'power3.out' });
                gsap.to(".header__logo-link", { duration: 2, height: '36px', ease: 'power3.out' });
                gsap.to("#overlay-testimonials", { duration: 2, y: '-100%', ease: 'power3.out', onComplete: onReverseComplete });
                return;
            }

            // Close for desktop.
            gsap.to('.hamburger__line4', { duration: 0.2, rotate: 0 });
            gsap.to('.hamburger__line2', { duration: 0.2, rotate: 0 });
            gsap.to('.hamburger__line1', { delay: 0.4, duration: 0.2, scaleX: 1 });
            gsap.to('.hamburger__line3', { delay: 0.4, duration: 0.2, scaleX: 1 });
            gsap.to('.hamburger__line3', { delay: 0.9, duration: 0.2, width: '20px', autoAlpha: 1 });
            gsap.to("#header", { duration: 2, width: '90px', ease: 'power3.out' });
            gsap.to(".header__logo-link", { duration: 2, width: '49px', ease: 'power3.out' });
            gsap.to("#overlay-testimonials", { duration: 2, x: '-100%', ease: 'power3.out', onComplete: onReverseComplete });
        },

        closeMenu() {
            const onReverseComplete = () => {
                this.$root.inTransition = false;
                this.$root.showNavigation = false;
                gsap.set(['#header', '#overlay', '.header__logo-link', '.hamburger__line', '.header__logo-mobile .fill', '.current-language', '.language-selector a', '.language-selector__arrow'], { clearProps: "all" });

                document.body.classList.remove('menu-open');
                enableBodyScroll(document.querySelector('#overlay'));
            };

            gsap.killTweensOf(['.hamburger__line']);

            //close for mobile
            if (window.matchMedia("(max-width: 1023px)").matches) {
                gsap.to(['.navigation__info', '.navigation__social', '.navigation__copyright'], { duration: 0.4, stagger: -0.1, autoAlpha: 0, ease: 'power3.out' });
                gsap.to('.navigation__item', { duration: 0.4, autoAlpha: 0, ease: 'power3.out', stagger: -0.1 });
                gsap.to('.navigation__bottom-border', { scaleX: 0, duration: 0.4, ease: 'power1.out' });
                gsap.to('.navigation-container', { autoAlpha: 0, duration: 0.1, ease: 'power1.out' });
                gsap.to('.hamburger__line4', { duration: 0.2, rotate: 0 });
                gsap.to('.hamburger__line2', { duration: 0.2, rotate: 0 });
                gsap.to('.hamburger__line1', { delay: 0.4, duration: 0.2, scaleX: 1 });
                gsap.to('.hamburger__line3', { delay: 0.4, duration: 0.2, scaleX: 1 });
                gsap.to('.hamburger__line3', { delay: 0.9, duration: 0.2, width: '20px', autoAlpha: 1 });
                gsap.to("#header", { delay: 0.4, duration: 1, height: '72px', ease: 'power3.out' });
                gsap.to(".header__logo-link", { delay: 0.6, duration: 0.5, height: '36px', ease: 'power3.out' });
                gsap.to(".overlay__background", { delay: 0.4, duration: 1, y: '-100%', ease: 'power4.out', onComplete: onReverseComplete });

                if (this.$root.lightHeader) {
                    gsap.to(".hamburger__line", { delay: 0.4, duration: 0.8, backgroundColor: '#fff', ease: 'power4.out' });
                    gsap.to([".current-language", ".language-selector a"], { delay: 0.4,  duration: 0.8, color: '#fff', ease: 'power4.out' });
                    gsap.to([".language-selector__arrow"], { delay: 0.4,  duration: 0.8, stroke: '#fff', ease: 'power4.out' });
                    gsap.to(".header__logo-mobile .fill", { delay: 0.8, duration: 0.4, fill: '#fff', ease: 'power4.out' });
                }

                return;
            }

            //close for desktop
            gsap.to('.navigation__item', { duration: 0.4, autoAlpha: 0, ease: 'power3.out', stagger: -0.1 });
            gsap.to(['.navigation__info', '.navigation__social', '.navigation__copyright'], { duration: 0.4, stagger: -0.1, autoAlpha: 0, ease: 'power3.out' });
            gsap.to('.navigation__bottom-border', { scaleY: 0, duration: 0.4, ease: 'power1.out' });
            gsap.to('.navigation-container', { autoAlpha: 0, duration: 0.1, ease: 'power1.out' });
            gsap.to('.hamburger__line4', { duration: 0.2, rotate: 0 });
            gsap.to('.hamburger__line2', { duration: 0.2, rotate: 0 });
            gsap.to('.hamburger__line1', { delay: 0.4, duration: 0.2, scaleX: 1 });
            gsap.to('.hamburger__line3', { delay: 0.4, duration: 0.2, scaleX: 1 });
            gsap.to('.hamburger__line3', { delay: 0.9, duration: 0.2, width: '20px', autoAlpha: 1 });
            gsap.to("#header", { delay: 0.4, duration: 1, width: '90px', ease: 'power3.out' });
            gsap.to(".header__logo-link", { delay: 0.7, duration: 0.5, width: '49px', ease: 'power3.out' });
            gsap.to(".overlay__background", { delay: 0.4, duration: 1, x: '-100%', ease: 'power4.out', onComplete: onReverseComplete });

            if (this.$root.lightHeader) {
                gsap.to(".hamburger__line", { delay: 0.4, duration: 0.8, backgroundColor: '#fff', ease: 'power4.out' });
                gsap.to([".current-language", ".language-selector a"], { delay: 0.4,  duration: 0.8, color: '#fff', ease: 'power4.out' });
                gsap.to([".language-selector__arrow"], { delay: 0.4,  duration: 0.8, stroke: '#fff', ease: 'power4.out' });
                gsap.to(".header__logo-desktop path", { delay: 0.8, duration: 0.4, fill: '#fff', ease: 'power4.out' });
            }
        },

        closeMenuFromPageTransition() {
            if (!this.$root.showNavigation) {
                return;
            }

            this.$root.inTransition = false;
            this.$root.showNavigation = false;
            gsap.set([
                '.navigation__info', '.navigation__social', '.navigation__copyright',
                '#header', '#overlay',
                '.header__logo-link',
                '.hamburger__line',
                '.header__logo-mobile .fill',
                '.navigation__item',
                '.navigation__bottom-border',
                '.navigation-container',
                '.overlay__background',
                '.header__logo-desktop path',
                '.current-language',
                '.language-selector a',
                '.language-selector__arrow',

            ], { clearProps: "all" });

            document.body.classList.remove('menu-open');
            enableBodyScroll(document.querySelector('#overlay'));
        },

        openMenu() {
            this.$root.showNavigation = true;

            const onComplete = () => {
                this.$root.inTransition = false;
            };

            document.body.classList.add('menu-open');
            disableBodyScroll(document.querySelector('#overlay'));


            gsap.killTweensOf('.navigation-item');
            gsap.set('.navigation__item', { autoAlpha: 0 });

            // open for mobile
            if (window.matchMedia("(max-width: 1023px)").matches) {
                gsap.to('.hamburger__line3', { duration: 0.3, width: '25px' });
                gsap.to("#header", { duration: 2, height: '107px', ease: 'power3.out' });
                gsap.to(".overlay__background", { duration: 0.3, y: 0, ease: 'power4.out' });
                gsap.to('.navigation-container', { autoAlpha: 1, duration: 0.1, ease: 'power1.out' });
                gsap.to('.navigation__bottom-border', { scaleX: 1, duration: 1.6, ease: 'power1.out' });
                gsap.to(".hamburger__line", { duration: 0.8, backgroundColor: '#1B4540', ease: 'power4.out' });
                gsap.to([".current-language", ".language-selector a"], { duration: 0.8, color: '#1B4540', ease: 'power4.out' });
                gsap.to([".language-selector__arrow"], { duration: 0.8, stroke: '#1B4540', ease: 'power4.out' });
                gsap.to(".header__logo-mobile .fill", { duration: 0.8, fill: '#1B4540', ease: 'power4.out' });
                gsap.to(".header__logo-link", { duration: 1, height: '54px', ease: 'power3.out' });

                gsap.to('.hamburger__line1', { delay: 0.4, duration: 0.3, scaleX: '0' });
                gsap.to('.hamburger__line3', { delay: 0.4, duration: 0.3, scaleX: '0' });
                gsap.to('.hamburger__line2', { delay: 0.9, duration: 0.3, rotate: '-45deg' });
                gsap.to('.hamburger__line4', { delay: 0.9, duration: 0.3, rotate: '45deg' });
                gsap.to('.navigation__bottom', { delay: 1.6, duration: 2, autoAlpha: 1 });
                gsap.to(['.navigation__info', '.navigation__social', '.navigation__copyright'], { delay: 1, duration: 2, stagger: 0.1, autoAlpha: 1, ease: 'power3.out' });
                gsap.to('.navigation__item', { delay: 0.3, duration: 2, autoAlpha: 1, ease: 'power3.out', stagger: 0.1, onComplete: onComplete });
                return;
            }

            // open for desktop
            gsap.to('.hamburger__line3', { duration: 0.3, width: '25px' });
            gsap.to("#header", { duration: 2, width: '145px', ease: 'power3.out' });
            gsap.to(".overlay__background", { duration: 2, x: 0, ease: 'power4.out' });
            gsap.to('.navigation-container', { autoAlpha: 1, duration: 0.1, ease: 'power1.out' });
            gsap.to('.navigation__bottom-border', { scaleY: 1, duration: 1.6, ease: 'power1.out' });
            gsap.to(".hamburger__line", { duration: 0.8, backgroundColor: '#1B4540', ease: 'power4.out' });
            gsap.to([".current-language", ".language-selector a"], { duration: 0.8, color: '#1B4540', ease: 'power4.out' });
            gsap.to([".language-selector__arrow"], { duration: 0.8, stroke: '#1B4540', ease: 'power4.out' });
            gsap.to(".header__logo-desktop path", { duration: 0.8, fill: '#1B4540', ease: 'power4.out' });

            gsap.to(".header__logo-link", { duration: 2, width: '77px', ease: 'power3.out' });
            gsap.to('.hamburger__line1', { delay: 0.4, duration: 0.3, scaleX: '0' });
            gsap.to('.hamburger__line3', { delay: 0.4, duration: 0.3, scaleX: '0' });
            gsap.to('.hamburger__line2', { delay: 0.9, duration: 0.3, rotate: '-45deg' });
            gsap.to('.hamburger__line4', { delay: 0.9, duration: 0.3, rotate: '45deg' });
            gsap.to(['.navigation__info', '.navigation__social', '.navigation__copyright'], { delay: 1, duration: 2, stagger: 0.1, autoAlpha: 1, ease: 'power3.out' });
            gsap.to('.navigation__item', { delay: 0.3, duration: 2, autoAlpha: 1, ease: 'power3.out', stagger: 0.1, onComplete: onComplete });
        },

        onMenuItemClick(event) {
            if (this.$root.section === event.target.dataset.section) {
                this.toggleMenu();
                return;
            }
            const el = event.currentTarget;

            this.$root.router.transition = 'from-menu';

            page(el.href);
        },
    }
});
